// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c748dc3e","396":"c78d329a","398":"948667bb","436":"0d6b19bf","453":"f7d6ee43","455":"d0d8121a","461":"a2efd72f","943":"139355a7"}[chunkId] + ".chunk.js";
};